import { render } from "./pl35.vue?vue&type=template&id=507734f0"
import script from "./pl35.vue?vue&type=script&lang=js"
export * from "./pl35.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__